import { render, staticRenderFns } from "./portfolio-card.vue?vue&type=template&id=1ebb7e4b&scoped=true"
import script from "./portfolio-card.vue?vue&type=script&lang=js"
export * from "./portfolio-card.vue?vue&type=script&lang=js"
import style0 from "./portfolio-card.vue?vue&type=style&index=0&id=1ebb7e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb7e4b",
  null
  
)

export default component.exports